import React, { useEffect } from "react";
import {
  Container,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { CustomBootstrapTable } from 'components/Table/CustomBootstrapTable';
import {  subscriptionruLESlist } from "helpers/tableDataMapper";
import { useSelector, useDispatch } from "react-redux";
import { getSubscriptionRules } from "store/actions";
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { history } from "helpers/utils";

const SubscriptionRuleList = (props) => {
    const dispatch = useDispatch();

    const { subscriptionRulesList } = useSelector(state => ({
        subscriptionRulesList: state.subscriptionRule.subscriptionRulesList,
    }));
    
    useEffect(() => {
        let queryPayload = {
            search: '',
        }
        dispatch(getSubscriptionRules(queryPayload));
    }, [dispatch, props]);

    const getApplicationDetails = (row) => {
        props.history.push(`/staff/subscriptions/rules/detail/${row[7]}`)
    }
    const filterList = (queryPayload) => {
        let payload = {
            ...queryPayload,
        }
        dispatch(getSubscriptionRules(payload))
    }

    const getTableColumns = () => {
        let editObj = {
            label: "Actions",
            name: '',
            options: { 
                filter: true,
                sort: false, 
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div className='d-flex align-items-center justify-content-center'>
                        <div
                            className="ms-1"
                            onClick={() => getApplicationDetails(tableMeta?.rowData)}
                        >
                            <MdEdit size={16}/>
                        </div>  
                    </div>
                )
            }
        }
        let newtable = [...subscriptionruLESlist,editObj]
         return newtable
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Subscription Rules" breadcrumbItem="Subscription Rules List" />
                    <CustomBootstrapTable 
                        rows = {subscriptionRulesList}
                        columns = {getTableColumns()}
                        isLoading={false}
                        showCreateBtn = {true}
                        keyField={'_id'}
                        createBtnLabel="Create Rule"
                        onCreateRedirect = {`/staff/subscriptions/rules/detail`}
                        getApplicationDetails={(row) => null}
                        showStatusFilter={false}
                        showDateFilter={false}
                        history = {props.history}
                        filterList = {(...params) => filterList(...params)}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export { SubscriptionRuleList }